module.exports = __webpack_public_path__ + "img/pic-paging-faq-3.577b8bd3.jpg";